export default __webpack_public_path__ + "static/media/payment-paybyme.6acb2c62.svg";